import React from "react";

const FormButton = ({ text, disabled, action, className }) => (
	<button className={`waves-light ${className} search-btn ${disabled ? disabled : ""}`} disabled={disabled} onClick={action}>
		{text}
	</button>
);

export default FormButton;
